(() => {
  const SELECTOR_CHECKOUT_FORM = 'form.checkout';
  const SELECTOR_CHECKOUT_FORM_ROW = '.form-row';
  const SELECTOR_CHECKOUT_FORM_ROW_PAYPO = `${SELECTOR_CHECKOUT_FORM_ROW}.paypo-row`;
  const SELECTOR_PAYMENT_METHODS_INPUT = 'input[name="payment_method"]';
  const PAYMENT_METHOD_VALUE_PAYPO = 'przelewy24_extra_227';
  const VISSIBLE_CLASS = 'paypo-visible';
  
  const getPaymentMethod = () => {
    return jQuery(`${SELECTOR_CHECKOUT_FORM} ${SELECTOR_PAYMENT_METHODS_INPUT}:checked`).val();
  };

  const isSelectedPayPo = () => {
    return PAYMENT_METHOD_VALUE_PAYPO === getPaymentMethod();
  }

  const showPayPoCheckoutFields = () => {
    jQuery(SELECTOR_CHECKOUT_FORM_ROW_PAYPO).each((index, element) => {
      if (!element.classList.contains(VISSIBLE_CLASS)) {
        element.classList.add(VISSIBLE_CLASS);
      }
    })
  };

  const hidePayPoCheckoutFields = () => {
    jQuery(SELECTOR_CHECKOUT_FORM_ROW_PAYPO).each((index, element) => {
      if (element.classList.contains(VISSIBLE_CLASS)) {
      element.classList.remove(VISSIBLE_CLASS);
    }
  })
  };

  const setPayPoFields = () => {
    if (isSelectedPayPo()) {
      showPayPoCheckoutFields();
    } else {
      hidePayPoCheckoutFields();
    }
  };

  const initPayPo = () => {
    jQuery(document.body).on('payment_method_selected', () => {
      setPayPoFields();
    });
  };

  document.addEventListener('DOMContentLoaded' ,() => {
    initPayPo();
  });
})()